<template>
  <div>
    <table class="qrw-simple-table">
      <thead>
        <th class="w-10 num">{{$t('subscription.transactions.number')}}</th>
        <th>{{$t('subscription.transactions.date')}}</th>
        <th class="w-10">{{$t('subscription.transactions.time')}}</th>
        <th>{{$t('subscription.transactions.system')}}</th>
        <th>{{$t('subscription.transactions.method')}}</th>
        <th class="w-10">{{$t('subscription.transactions.sum')}}</th>
        <th>{{$t('subscription.transactions.status')}}</th>
      </thead>
      <tbody>
        <tr v-for="(item,index) in transactions" :key="index">
          <td class="w-10">{{ item.banking_id }}</td>
          <td>{{ item.created_at | formatDate }}</td>
          <td class="w-10">{{ item.created_at | formatTime }}</td>
          <td>
            <!-- <img :src="`/icons/mode-${item.mode == 'inside_lite' ? 'inside-lite' : item.mode}.svg`" alt /> -->
            {{ formatModeName(item.mode)}}
          </td>
          <td>{{ item.card_type.toUpperCase()}} {{ item.card_mask }}</td>
          <td class="w-10">{{ item.amount }} {{ item.currency }}</td>
          <td>
            <span
              class="c-green"
              v-if="item.status == 'success'"
            >{{$t('subscription.transactions.success')}}</span>
            <span class="c-white" v-else-if="item.status == 'reversed'">
              {{$t('subscription.transactions.reversed' )}}
            </span>
            <span class="c-red" v-else>{{$t('subscription.transactions.error')}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import SubscriptionAPI from "@/api/subscription";

import ModeIcon from "@/components/ModeIcon.vue";

import { saveAs } from "file-saver";

import moment from 'moment'

export default {
  data() {
    return {
      transactions: []
    };
  },
  methods: {
    formatModeName(mode) {
      return mode
        .split("_")
        .join(" ")
        .toUpperCase();
    },
    exportToCsv() {
      let csv = `ID,Дата,Час,Система,Метод оплати,Сума,Комісія,Статус\n`;

      this.transactions.forEach((item, index) => {
        const fields = [
          item.banking_id,
          moment(item.created_at).format("DD.MM.YYYY"),
          moment(item.created_at).format("HH:mm"),
          item.mode,
          `${item.card_type} ${item.card_mask}`,
          item.amount,
          item.status
        ];

        csv += fields.map(f => `"${f}"`).join(",") + "\n";
      });

      const blob = new Blob([csv], {
        type: "text/csv"
      });

      saveAs(blob, `systems-transactions-${Date.now()}.csv`);
    }
  },
  components: {
    IQOS
  },
  mounted() {
    // this.transactions = [{
    //   banking_id: '1234',
    //   created_at: new Date(),
    //   mode: 'delivery',
    //   card_type: 'Mastercard',
    //   card_mask: '59*82',
    //   amount: 1500,
    //   status: 'success'
    // },
    // {
    //   banking_id: '1234',
    //   created_at: new Date(),
    //   mode: 'delivery',
    //   card_type: 'Mastercard',
    //   card_mask: '59*82',
    //   amount: 1500,
    //   status: 'success'
    // }];

    SubscriptionAPI.getTransactions(this.$store.state.cafe._id)
      .then(data => {
        this.transactions = data.transactions;
      })
      .catch(error => {
        this.$store.dispatch("showError", "subscription_error");
      });
  }
};
</script>

<style scoped>
.qrw-simple-table thead th, .qrw-simple-table td {
  width: 15% !important;
}

tbody {
  display: inline-table;
}

.qrw-simple-table .w-10 {
  width: 10% !important;
}

.w-10.num {
  padding: 1vh 1vh 0;
}

</style>